/* Moon Tide — theme interactions (no dependencies) */
(function () {
  'use strict';
  document.documentElement.classList.add('js');

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Sticky header shadow / compact logo */
  var header = document.querySelector('[data-header]');
  if (header) {
    var onScroll = function () { header.classList.toggle('is-scrolled', window.scrollY > 40); };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* Mobile menu drawer */
  var drawer = document.querySelector('[data-drawer]');
  var lastFocus = null;
  function openDrawer() {
    if (!drawer) return;
    lastFocus = document.activeElement;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.querySelectorAll('[data-drawer-open]').forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
    document.body.style.overflow = 'hidden';
    var first = drawer.querySelector('[data-drawer-close]');
    if (first) first.focus();
  }
  function closeDrawer() {
    if (!drawer || !drawer.classList.contains('is-open')) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.querySelectorAll('[data-drawer-open]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    document.body.style.overflow = '';
    if (lastFocus) lastFocus.focus();
  }
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-drawer-open]')) openDrawer();
    if (e.target.closest('[data-drawer-close]')) closeDrawer();
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeDrawer();
    if (e.key === 'Tab' && drawer && drawer.classList.contains('is-open')) {
      var f = drawer.querySelectorAll('a, button, select, input');
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });

  /* Marquee pause/play (WCAG 2.2.2) */
  document.querySelectorAll('[data-marquee-toggle]').forEach(function (btn) {
    var marquee = btn.closest('[data-marquee]');
    btn.addEventListener('click', function () {
      var paused = marquee.classList.toggle('is-paused');
      btn.setAttribute('aria-pressed', String(paused));
      btn.setAttribute('aria-label', paused ? 'Play scrolling banner' : 'Pause scrolling banner');
      btn.querySelector('[data-icon-pause]').hidden = paused;
      btn.querySelector('[data-icon-play]').hidden = !paused;
    });
  });

  /* Hero starfield */
  document.querySelectorAll('[data-stars]').forEach(function (field) {
    var count = parseInt(field.getAttribute('data-stars'), 10) || 70;
    var frag = document.createDocumentFragment();
    for (var i = 0; i < count; i++) {
      var s = document.createElement('span');
      var size = Math.random() < 0.15 ? 3 : Math.random() < 0.5 ? 2 : 1;
      s.style.cssText = 'left:' + (Math.random() * 100).toFixed(2) + '%;top:' + (Math.random() * 85).toFixed(2) + '%;width:' + size + 'px;height:' + size + 'px;animation-delay:' + (Math.random() * 4).toFixed(2) + 's;animation-duration:' + (3 + Math.random() * 4).toFixed(2) + 's';
      frag.appendChild(s);
    }
    field.appendChild(frag);
  });

  /* Reveal on scroll */
  var reveals = document.querySelectorAll('.reveal');
  if (!reduceMotion && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) { entry.target.classList.add('is-visible'); io.unobserve(entry.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    reveals.forEach(function (el, i) {
      var siblings = el.parentElement ? Array.prototype.indexOf.call(el.parentElement.children, el) : 0;
      el.style.transitionDelay = Math.min(siblings, 5) * 60 + 'ms';
      io.observe(el);
    });
  } else {
    reveals.forEach(function (el) { el.classList.add('is-visible'); });
  }

  /* Quantity steppers */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qty]');
    if (!btn) return;
    var input = btn.parentElement.querySelector('input');
    var step = btn.getAttribute('data-qty') === 'plus' ? 1 : -1;
    var min = parseInt(input.min || '0', 10);
    input.value = Math.max(min, (parseInt(input.value, 10) || 0) + step);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* Localization selector auto-submit */
  document.querySelectorAll('[data-localization] select').forEach(function (select) {
    select.addEventListener('change', function () { select.form.submit(); });
  });

  /* Launch countdown */
  document.querySelectorAll('[data-countdown]').forEach(function (el) {
    var launch = Date.parse(el.getAttribute('data-countdown'));
    if (isNaN(launch)) return;
    var daysEl = el.querySelector('[data-countdown-days]');
    var unitEl = el.querySelector('[data-countdown-unit]');
    function tick() {
      var diff = Math.max(0, launch - Date.now());
      var days = Math.floor(diff / 864e5);
      if (daysEl.textContent !== String(days)) {
        daysEl.textContent = days;
        unitEl.textContent = days === 1 ? 'day' : 'days';
      }
    }
    tick();
    setInterval(tick, 60000);
  });

  /* Subscription sign-up: fold chosen tropes into customer tags */
  document.querySelectorAll('[data-signup-form]').forEach(function (form) {
    var tags = form.querySelector('[data-signup-tags]');
    var base = tags.value;
    form.addEventListener('submit', function () {
      var chosen = Array.prototype.map.call(form.querySelectorAll('[data-trope]:checked'), function (c) { return 'trope: ' + c.value; });
      var other = form.querySelector('[data-trope-other]');
      if (other && other.value.trim()) chosen.push('trope: ' + other.value.trim().replace(/\s*,\s*/g, ' / ').slice(0, 60));
      tags.value = [base].concat(chosen).join(', ');
      form.querySelectorAll('[data-trope]').forEach(function (c) { c.disabled = true; });
      if (other) other.disabled = true;
    });
  });

  /* Work with us: show the fields for the chosen collaborator type */
  document.querySelectorAll('[data-collab-form]').forEach(function (form) {
    var select = form.querySelector('[data-collab-select]');
    var groups = form.querySelectorAll('[data-collab-group]');
    function sync() {
      groups.forEach(function (g) {
        var on = g.getAttribute('data-collab-group') === select.value;
        g.hidden = !on;
        g.disabled = !on;
      });
    }
    select.addEventListener('change', sync);
    var preset = new URLSearchParams(window.location.search).get('type');
    if (preset && select.querySelector('option[value="' + preset + '"]')) select.value = preset;
    sync();
  });

  /* Product: keep hidden selling_plan field in sync with purchase option */
  document.querySelectorAll('[data-product-form]').forEach(function (form) {
    var planInput = form.querySelector('input[name="selling_plan"]');
    var priceEl = document.querySelector('[data-product-price]');
    form.addEventListener('change', function (e) {
      if (e.target.name === 'purchase_option' && planInput) {
        planInput.value = e.target.value === 'one-time' ? '' : e.target.value;
        if (priceEl && e.target.dataset.price) priceEl.textContent = e.target.dataset.price;
      }
    });
  });
})();
